module.exports = __webpack_public_path__ + "img/x2.47835892.png";